// Weekly status email settings on NomOS's unversioned route (monad/api/weekly_status_email.py). Every
// authorization rule is the server's; nothing here decides access. (Moved out of the identity family when
// user management became NomOS records and verbs, SEN-438.)
import type {
  WeeklyStatusEmailPreview, WeeklyStatusEmailSettings, WeeklyStatusEmailSettingsUpdate,
} from '@/types/weeklyStatusEmail';
import { getConfig, nomosFetch } from '../client';
import type { AnyFn, NomosRegistry } from '../registry';

const slug = () => encodeURIComponent(getConfig().tenant);
const route = (path: string, method = 'GET', body?: unknown) =>
  nomosFetch(method, `/tenants/${slug()}${path}`, body, { tenantScoped: false });

const pickSettings = (s: WeeklyStatusEmailSettings & { automation_id?: unknown }): WeeklyStatusEmailSettings => ({
  recipients: s.recipients, send_dow: s.send_dow, send_hour: s.send_hour, send_minute: s.send_minute,
  last_sent_week: s.last_sent_week,
});

async function getWeeklyStatusEmailSettings(): Promise<WeeklyStatusEmailSettings> {
  return pickSettings(await route('/weekly-status-email/settings') as WeeklyStatusEmailSettings);
}

async function updateWeeklyStatusEmailSettings(body: WeeklyStatusEmailSettingsUpdate): Promise<WeeklyStatusEmailSettings> {
  return pickSettings(await route('/weekly-status-email/settings', 'PUT', body) as WeeklyStatusEmailSettings);
}

async function previewWeeklyStatusEmail(): Promise<WeeklyStatusEmailPreview> {
  return await route('/weekly-status-email/preview') as WeeklyStatusEmailPreview;
}

async function sendWeeklyStatusEmailPreview(): Promise<{ queued: boolean; to: string }> {
  return await route('/weekly-status-email/send-preview', 'POST') as { queued: boolean; to: string };
}

export const weeklyStatusEmailImpl: NomosRegistry = {
  getWeeklyStatusEmailSettings: getWeeklyStatusEmailSettings as unknown as AnyFn,
  updateWeeklyStatusEmailSettings: updateWeeklyStatusEmailSettings as unknown as AnyFn,
  previewWeeklyStatusEmail: previewWeeklyStatusEmail as unknown as AnyFn,
  sendWeeklyStatusEmailPreview: sendWeeklyStatusEmailPreview as unknown as AnyFn,
};
